"use strict";
/**
 * @license
 * Copyright 2022 SOUTHWORKS UK LTD All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/southworks/codeverter/blob/main/LICENSE
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Method = void 0;
const typescript_1 = require("typescript");
const function_1 = require("./function");
class Method extends function_1.Function {
    parse(node) {
        var _a;
        super.parse(node);
        this.static = ((_a = node.modifiers) === null || _a === void 0 ? void 0 : _a.find(m => m.kind == typescript_1.SyntaxKind.StaticKeyword)) != null;
    }
}
exports.Method = Method;
